import axios from 'axios';

// Create an axios instance with the correct base URL
// When behind Nginx proxy, we should use the same origin
// No need to specify a different URL as Nginx will proxy /api/ to our server
const api = axios.create({
  baseURL: window.location.hostname === 'localhost' 
    ? 'http://localhost:3001'
    : window.location.origin,
});

// Add a response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default api; 